import { differenceInCalendarDays } from 'date-fns';
import type { AuditLogEntry } from '@core/api/auditLog';

export function orderHistoryChanges(
  entry: AuditLogEntry
): AuditLogEntry['changes'] {
  if (!entry.changes || !('itemSummary' in entry.changes)) {
    return entry.changes;
  }
  const changes = { ...entry.changes };
  delete changes.itemSummary;
  return Object.keys(changes).length > 0 ? changes : null;
}

export function historyGapLabel(newer: Date, older: Date): string | null {
  const days = differenceInCalendarDays(newer, older);
  if (days <= 1) {
    return null;
  }
  if (days < 14) {
    return `${days} days earlier`;
  }
  if (days < 60) {
    const weeks = Math.round(days / 7);
    return weeks === 1 ? '1 week earlier' : `${weeks} weeks earlier`;
  }
  if (days < 365) {
    const months = Math.round(days / 30);
    return months === 1 ? '1 month earlier' : `${months} months earlier`;
  }
  const years = Math.round(days / 365);
  return years === 1 ? '1 year earlier' : `${years} years earlier`;
}
